import React from 'react';
import useIsDesktop from '../../hooks/useIsDesktop';
import Reveal from './Reveal';

const STEPS = [
  { n: 1, title: 'Register', text: 'Create your account as a tenant, landlord or admin.' },
  { n: 2, title: 'Get your unit linked', text: 'An admin or landlord approves you and links your house.' },
  { n: 3, title: 'Pay & track via M-Pesa', text: 'Pay rent instantly and see every invoice and receipt.' },
];

function HowItWorks() {
  const isDesktop = useIsDesktop();

  return (
    <section style={styles.section}>
      <Reveal as="h2" style={styles.heading}>How it works</Reveal>
      <div style={{ ...styles.row, flexDirection: isDesktop ? 'row' : 'column' }}>
        {STEPS.map((s, i) => (
          <React.Fragment key={s.n}>
            <Reveal style={styles.step}>
              <div style={styles.stepNum}>{s.n}</div>
              <h3 style={styles.stepTitle}>{s.title}</h3>
              <p style={styles.stepText}>{s.text}</p>
            </Reveal>
            {isDesktop && i < STEPS.length - 1 && <div style={styles.connector} />}
          </React.Fragment>
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    maxWidth: '1000px',
    margin: '0 auto',
    padding: '24px 24px 72px',
  },
  heading: {
    fontFamily: 'var(--font-display)',
    fontSize: 'clamp(24px, 3vw, 32px)',
    fontWeight: 800,
    color: 'var(--color-ink)',
    textAlign: 'center',
    margin: '0 0 36px',
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '16px',
  },
  step: {
    flex: 1,
    textAlign: 'center',
    padding: '0 8px',
  },
  stepNum: {
    width: '36px',
    height: '36px',
    margin: '0 auto 14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-text-on-brand)',
    fontWeight: 800,
    fontSize: '15px',
  },
  stepTitle: {
    fontSize: '16px',
    fontWeight: 700,
    color: 'var(--color-ink)',
    margin: '0 0 6px',
  },
  stepText: {
    fontSize: '13.5px',
    color: 'var(--color-ink-soft)',
    lineHeight: 1.5,
    margin: 0,
  },
  connector: {
    height: '1px',
    flex: '0 0 40px',
    backgroundColor: 'var(--color-border)',
    marginTop: '18px',
  },
};

export default HowItWorks;
